<script setup>
import AddressBlock from './components/AddressBlock.vue';
import FieldInput from '../../components/ui/FieldInput.vue';
import FieldRadioGroup from '../../components/ui/FieldRadioGroup.vue';
import FieldSelect from '../../components/ui/FieldSelect.vue';
import FieldCheckbox from '../../components/ui/FieldCheckbox.vue';
import Button from '../../components/ui/Button.vue';

import message from "../../lib/message";
import api from "../../lib/api";
import ModelUser from './models/user';
import decoder from '../../lib/decoder'
import { getApiUrl, checkDataElement} from "../base";
import {onMounted,getCurrentInstance, ref, computed} from "vue";

/* global BX */
/* global Mango */

let input = {
    user: null,
    billingUser: null,
    arParams: null
};
const constant = ModelUser.constant;
const user = ref(new ModelUser());
const loader = ref({ data: false, process: 0});

const props = defineProps({
    isMobile: {
        type: Boolean,
        default: false
    },
    sessid: {
        type: String,
        default: ''
    }
});
let apiUrl = '';
const app = getCurrentInstance();
const appData = window[app.type.name + 'Data'];
if (appData['input']) {
    input = appData['input'];
}
if (input) {
    user.value = ModelUser.decode(input.user, input.billingUser)
}

if (user.value.id > 0) {
    if (user.value.fields.user_type.value > 0 || input.hasBillingData) {
        user.value.fields.user_type.disabled = true
    }
}

if (!user.value.fields.user_type.value && input && input.arParams) {
    if (input.arParams.STEP === ModelUser.constant.step.PHIS) {
        user.value.fields.user_type.value = ModelUser.constant.userType.PHIS
    } else if (input.arParams.STEP === ModelUser.constant.step.LEGAL) {
        user.value.fields.user_type.value = ModelUser.constant.userType.LEGAL
    }
}

onMounted(() => {
    apiUrl = getApiUrl();
})

const userTypesOptions = computed(() => {
    let field = user.value.fields.user_type;

    return field.values.map(item => {
        return {
            value: item.value,
            title: item.title,
            disabled: field.disabled
        }
    })
});
const legalTypesOptions = computed(() => {
    let field = user.value.fields.legal_type;

    return field.values.map(item => {
        return {
            value: item.value,
            title: item.title
        }
    })
});
const titleClass = computed(() => {
    if (props.isMobile === true) {
        return ['h3', 'mt-2']
    }
    return ['h2', 'mt-0']
});

const changeActualAddress = (checked) => {
    user.value.fields.address_legal_equal_actual.value = checked;
    user.value.fields.company_legal_address.value.disabled = checked;
};
const fillCompanyFieldsFromSuggestion = (item) => {
    if (!item || !item.data) {
        return
    }
    let data = item.data;
    let fields = user.value.fields;
    fields.inn.value = decoder.stringValue(data['inn'], '');
    fields.kpp.value = decoder.stringValue(data['kpp'], '');
    fields.ogrn.value = decoder.stringValue(data['ogrn'], '');
    fields.company_title.value = decoder.stringValue(decoder.getObjectValue(data, 'name.full_with_opf'), '');

    let address = fields.company_address.value;
    address.fields.postal_code.value = decoder.stringValue(decoder.getObjectValue(data, 'address.data.postal_code'), '');
    address.fields.city.value = getCityFromSuggestionData(decoder.getObjectValue(data, 'address.data'));
};
const fillBankFieldsFromSuggestion = (data) => {
    if (!data) {
        return
    }

    let fields = user.value.fields;
    fields.bik.value = decoder.stringValue(data['bic'], '');
    fields.bank.value = decoder.stringValue(decoder.getObjectValue(data, 'name.payment'), '');
    fields.correspondent_account.value = decoder.stringValue(data['correspondent_account'], '');
    fields.bank_city.value = decoder.stringValue(data['payment_city'], '');
};
const getCityFromSuggestionData = (data) => {
    let part;

    part = decoder.stringValue(data['city_with_type'], '');
    if (part !== '') {
        return part
    }

    part = decoder.stringValue(data['source'], '');
    if (part !== '') {
        return part
    }

    return ''
};
const submit = ()  => {
    if (loader.value.process > 0) {
        return;
    }
    saveData(() => {
        sendDataToBilling(() => {
            createInvoice(() => {
                window.location.href = '/shop/cart/success.php'
            })
        })
    })
};
const saveData = (success) => {
    loader.value.process++;

    user.value.clearErrors();
    message.hideMessage();
    api.request(apiUrl, 'post', getActionFormData('save_data'))
        .then(() => {
            loader.value.process--;

            if (typeof success === 'function') {
                success()
            }
        })
        .catch((r) => {
            loader.value.process--;

            if (Object.hasOwnProperty.call(r, 'VALIDATE_ERRORS')) {
                let alertMessage = [],
                    errors = r['VALIDATE_ERRORS'];

                for (let key in errors) {
                    if (Object.hasOwnProperty.call(errors, key)) {
                        alertMessage.push(errors[key]);
                        user.value.setError(key, true);
                    }
                }

                if (alertMessage.length > 0) {
                    message.showWarning(alertMessage.join('<br />'));
                }
            } else if (Object.hasOwnProperty.call(r, 'error')) {
                message.showWarning(r['error']);
            }
        })
};
const sendDataToBilling = (success) => {
    loader.value.process++;

    message.hideMessage();

    api.request(apiUrl, 'post', getActionFormData('send_to_billing'))
        .then((r) => {
            loader.value.process--;

            if (Object.hasOwnProperty.call(r, 'product_status_alert')) {
                message.showWarning(r['product_status_alert'], true);
            }

            if (typeof success === 'function') {
                success()
            }
        })
        .catch((r) => {
            loader.value.process--;

            if (Object.hasOwnProperty.call(r, 'error')) {
                message.showWarning(r['error'], true);
            } else {
                message.showWarning('Ошибка при обновлении данных пользователя', true);
            }
        })
};
const createInvoice = (success) => {
    loader.value.process++;

    message.hideMessage();

    api.request(apiUrl, 'post', getActionFormData('create_invoice'))
        .then(() => {
            loader.value.process--;

            if (typeof success === 'function') {
                success()
            }
        })
        .catch(() => {
            loader.value.process--;

            message.showWarning('Ошибка при создании счета')
        })
};
const getActionFormData = (action) => {
    let formData = new FormData();
    if (action === 'save_data') {
        formData = user.value.formData();
        if (
            user.value.fields.user_type.disabled
            && !formData.has('user_type')
        ) {
            formData.append('user_type', user.value.fields.user_type.value);
        }
    }

    formData.append('action', action);
    formData.append('sessid', props.sessid);
    formData.append('SITE_ID', BX.message('SITE_ID'));
    formData.append('LANGUAGE_ID', BX.message('LANGUAGE_ID'));

    if (input && input.arParams) {
        let arParams = input.arParams;
        arParams.STEP = user.value.getStep();
        formData.append('arParams', JSON.stringify(arParams));
    }

    return formData;
};
</script>

<template>
    <div class="new-invoice mb-4 container">
        <h1 class="mb-2" :class="titleClass">
            Введите данные для получения счета
        </h1>

        <div v-if="loader.data" style="text-align: center">
            <img src="/uikit/svg/icons/loader.svg" style="width: 60px; height: 60px;">
        </div>

        <template v-else>
            <fieldset class="js-user-type" :disabled="user.fields.user_type.disabled">
                <div class="mb-2 bold">
                    Вы заключаете договор как
                </div>
                <FieldRadioGroup
                        v-model="user.fields.user_type.value"
                        dataElement="user_types_options"
                        :options="userTypesOptions"
                        optionClass="inline mb-3 mr-3"
                />
            </fieldset>
            <div class="js-tab-content" :data-element="checkDataElement('invoice-tab-'+user.fields.user_type.value)">
                <template v-if="user.fields.user_type.value === constant.userType.PHIS">
                    <fieldset>
                        <legend>Персональные данные</legend>
                        <div class="fields">
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldInput
                                            dataElement="user_last_name_field"
                                            v-model="user.fields.last_name.value"
                                            :disabled="user.fields.last_name.disabled"
                                            :error="user.fields.last_name.error"
                                            label="Фамилия"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            dataElement="user_name_field"
                                            v-model="user.fields.name.value"
                                            :disabled="user.fields.name.disabled"
                                            :error="user.fields.name.error"
                                            label="Имя"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            :dataElement="'user_second_name_field'"
                                            v-model="user.fields.second_name.value"
                                            :disabled="user.fields.second_name.disabled"
                                            :error="user.fields.second_name.error"
                                            label="Отчество"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Адрес</legend>
                        <AddressBlock
                                dataElement="user_address"
                                key="address"
                                v-model="user.fields.address.value"
                        />
                    </fieldset>
                </template>
                <template v-else-if="user.fields.user_type.value === constant.userType.LEGAL">
                    <fieldset>
                        <legend>Данные компании</legend>
                        <div class="fields">
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldSelect
                                            dataElement="user_legal_type_field"
                                            v-model="user.fields.legal_type.value"
                                            :disabled="user.fields.legal_type.disabled"
                                            :error="user.fields.legal_type.error"
                                            :options="legalTypesOptions"
                                    />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.inn.value"
                                            :disabled="user.fields.inn.disabled"
                                            :error="user.fields.inn.error"
                                            dataElement="user_inn_field"
                                            label="ИНН"
                                            suggestType="inn"
                                            @suggestSelect="fillCompanyFieldsFromSuggestion"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.kpp.value"
                                            :disabled="user.fields.kpp.disabled"
                                            :error="user.fields.kpp.error"
                                            dataElement="user_kpp_field"
                                            label="КПП"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.company_title.value"
                                            :disabled="user.fields.company_title.disabled"
                                            :error="user.fields.company_title.error"
                                            dataElement="user_company_field"
                                            label="Название организации"
                                    />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.ogrn.value"
                                            :disabled="user.fields.ogrn.disabled"
                                            :error="user.fields.ogrn.error"
                                            dataElement="user_ogrn_field"
                                            label="ОГРН"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.company_phone.value"
                                            :disabled="user.fields.company_phone.disabled"
                                            :error="user.fields.company_phone.error"
                                            dataElement="company_phone_field"
                                            type="phone"
                                            label="Телефон"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.company_fax.value"
                                            :disabled="user.fields.company_fax.disabled"
                                            :error="user.fields.company_fax.error"
                                            dataElement="company_fax_field"
                                            type="phone"
                                            label="Факс"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Адресa</legend>

                        <div class="bold mb-2">Фактический адрес</div>
                        <AddressBlock
                                dataElement="company_address"
                                key="companyAddress"
                                v-model="user.fields.company_address.value"
                        />

                        <div class="bold mb-2">Юридический адрес</div>
                        <div class="row mb-2">
                            <div class="col-sm-12">
                                <FieldCheckbox
                                        :value="user.fields.address_legal_equal_actual.value"
                                        :disabled="user.fields.address_legal_equal_actual.disabled"
                                        :error="user.fields.address_legal_equal_actual.error"
                                        label="Совпадает с фактическим адресом"
                                        dataElement="address_legal_equal_actual_field"
                                        @change="changeActualAddress"
                                />
                            </div>
                        </div>
                        <AddressBlock
                                dataElement="company_legal_address"
                                key="companyLegalAddress"
                                v-model="user.fields.company_legal_address.value"
                                :disabled="user.fields.address_legal_equal_actual.value"
                        />
                    </fieldset>
                    <fieldset>
                        <legend>Банковские данные организации</legend>
                        <div class="fields">
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.bik.value"
                                            :disabled="user.fields.bik.disabled"
                                            :error="user.fields.bik.error"
                                            dataElement="user_bik_field"
                                            label="БИК"
                                            suggestType="bank"
                                            @suggestSelect="fillBankFieldsFromSuggestion"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.bank.value"
                                            :disabled="user.fields.bank.disabled"
                                            :error="user.fields.bank.error"
                                            dataElement="user_bank_field"
                                            label="Банк"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.bank_city.value"
                                            :disabled="user.fields.bank_city.disabled"
                                            :error="user.fields.bank_city.error"
                                            dataElement="user_bank_city_field"
                                            label="Город банка"
                                    />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.payment_account.value"
                                            :disabled="user.fields.payment_account.disabled"
                                            :error="user.fields.payment_account.error"
                                            dataElement="user_payment_field"
                                            label="Расчетный счет"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <FieldInput
                                            v-model="user.fields.correspondent_account.value"
                                            :disabled="user.fields.correspondent_account.disabled"
                                            :error="user.fields.correspondent_account.error"
                                            dataElement="user_correspondent_account_field"
                                            label="Корреспондентский счет"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </template>
                <fieldset>
                    <legend></legend>
                </fieldset>
            </div>
            <Button
                    dataElement="cart_send"
                    size="md"
                    color="green"
                    title="Отправить"
                    :loading="loader.process > 0"
                    :disabled="loader.process > 0"
                    @click="submit"
            />
        </template>
    </div>
</template>

<script>
export default {
    name: "NewInvoicePage",
}
</script>

<style lang="scss">
@media (max-width: 768px) {
    .new-invoice .row-inline > [class*=col-], .new-invoice .row > [class*=col-] {
        margin: 0 0 10px 0;
    }

    .new-invoice .row-inline > [class*=col-]:last-child, .new-invoice .row > [class*=col-]:last-child {
        margin: 0;
    }
}
</style>